import {
  highmarkCommon,
  LinkHandler,
  AUTHED_WEBVIEW_URL_NAMES,
  SSO_URL_NAMES,
  getSsoUrl,
  getAuthedWebviewUrl,
  useCurrentRegionUbkHeader,
} from '@highmark-web/highmark-common';
import { formsLibrary } from '@leagueplatform/engen-capability-forms-web';
import { cobLibrary } from '@leagueplatform/engen-capability-cob-library';
import { accountManagementLibrary } from '@leagueplatform/engen-capability-account-management';
import { contactInfoLibrary } from '@leagueplatform/engen-capability-contact-information-library';
import { communicationLibrary } from '@leagueplatform/engen-capability-communication-preference-library';
import { pcpLibrary } from '@leagueplatform/engen-capability-primary-care-provider-library';
import { dlrLibrary } from '@leagueplatform/engen-capability-donate-life-registry';
import { sharedLibrary } from '@leagueplatform/engen-capability-shared-library';
import { documentCenter } from '@leagueplatform/engen-capability-document-center';
import { glossary } from '@leagueplatform/engen-capability-insurance-glossary';
import { easyPlanFAQ } from '@leagueplatform/engen-capability-easy-plan-faq';
import { easyPlan } from '@leagueplatform/engen-capability-easy-plan-home';
import { spendingAccount } from '@leagueplatform/engen-capability-spending-account';

// SDK initializers that do not use the Config API
export const initializeNonConfigSDKs = () => {
  highmarkCommon.config({
    highmarkContentUrl: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    highmarkMemberPortalUrl: import.meta.env.VITE_HIGHMARK_MEMBER_PORTAL_URL,
    highmarkRestApiUrl: `${import.meta.env.VITE_HIGHMARK_AXWAY_API}/digital`,
    highmarkSsoAppUrl: import.meta.env.VITE_HIGHMARK_SSO_APP_URL,
    feedbackSurveyUrl: import.meta.env.VITE_FEEDBACK_SURVEY_URL,
  });

  formsLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    useCurrentRegionUbkHeader,
    LinkHandler,
  });

  cobLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
  });

  accountManagementLibrary.config({
    LinkHandler,
    AUTHED_WEBVIEW_URL_NAMES,
    SSO_URL_NAMES,
    getAuthedWebviewUrl,
    getSsoUrl,
    useCurrentRegionUbkHeader,
    HIGHMARK_API_URL: `${import.meta.env.VITE_HIGHMARK_AXWAY_API}`,
  });

  contactInfoLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    useCurrentRegionUbkHeader,
  });

  communicationLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    HIGHMARK_AXWAY_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
  });

  dlrLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    useCurrentRegionUbkHeader,
  });

  pcpLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    useCurrentRegionUbkHeader,
  });

  sharedLibrary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    useCurrentRegionUbkHeader,
  });

  documentCenter.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    HIGHMARK_CDN_URL: import.meta.env.VITE_HIGHMARK_CONTENT_URL,
    enableUMLetters: false,
    enableWelcomeGuides: false,
    enableBenefitBooklet: false,
    enableSBC: false,
    enableEOP: false,
    enableRecentErrorHandling: false,
    enableCMLetters: false,
    useCurrentRegionUbkHeader,
  });

  glossary.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
  });

  easyPlanFAQ.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
  });

  easyPlan.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
  });
  spendingAccount.config({
    HIGHMARK_API_URL: import.meta.env.VITE_HIGHMARK_AXWAY_API,
    useCurrentRegionUbkHeader,
    LinkHandler,
  });
};
